const is_dev_build = process.env['NODE_ENV'] === 'development';

export const isDevBuild = () => is_dev_build;
